$(function() {
	checkInputErrors();

	$('form').not('.debug, .novalidate').attr('novalidate', 'novalidate').on('submit fake-submit', function(e) {
		var $form = $(this);
		var $submit = $form.find('[type=submit]');
		var errorItems = [];
		var loadingMax = $(this).data('loading-max') || 5;

		$form.removeClass('has-errors');

		if (e.type === 'submit' && !$form.hasClass('no-loader')) {
			$submit.prop('disabled', true).addClass('loading');
		}

		$form.find('.form-required .input-error[data-error-default!=""]').each(function() {
			var $item     = $(this);
			var fields    = $(this).data('error-fields').split(',');
            var hasErrors = false;
            var getField  = function(name) {
                return $form.find('[name="' + name + '"], [name^="' + name + '["], [name^="form_fields[' + name + ']"]');
            };

            // Remove the existing error first
            $item.text('');

			$.each(fields, function(key, value) {
				var $field = getField(value);

				if ($field.length === 0) {
					console.warn('Could not find field with name', value);
					return;
				}

				var type = $field.get(0).type;

				if (!$field.is(':visible')) {
					// Niet valideren als het veld niet eens zichtbaar is
					// Let op: Dit is een aanpassing die ook een update van custom-inputs.less vereist!
					return;
				}

				if ($form.hasClass('debug')) {
					return; // in debug mode niks client-side valideren
				}

				// Default checks
				switch (type) {
					default:
						if ($field.val() === '') {
                            hasErrors = true;
							errorItems.push({
                                item: $item
                            });
							return;
						}
						break;

					case 'checkbox':
					case 'radio':
						if ($field.filter(':checked').length === 0) {
                            hasErrors = true;
							errorItems.push({
                                item: $item
                            });
							return;
						}
				}

				// Additional checks
				if (type === 'email') {
					if ($field.val() !== '' && !/^.+@.+\..+$/.test($field.val())) {
                        hasErrors = true;
                        errorItems.push({
                            item: $item,
                            type: 'email'
                        });
					}
				}
			});

            if (!hasErrors && $(this).data('age')) {
                var minAge = $(this).data('age');
                var getAge = function(year, month, day) {
                    year  = '' + year;
                    month = '' + month;
                    day   = '' + day;

                    if (day.length === 1)   day   = '0' + day;
                    if (month.length === 1) month = '0' + month;

                    if (isNaN(Date.parse(year + '-' + month + '-' + day))) {
                        return 0;
                    }

                    var today   = new Date();
                    var age     = today.getFullYear() - year;

                    if (today.getMonth() + 1 < month || (today.getMonth() + 1 === month && today.getDate() < day)) {
                        age--;
                    }

                    if (age > 130 || age < 0) {
                        return 0;
                    }

                    return age;
                };

                var age = getAge(getField(fields[0]).val(), getField(fields[1]).val(), getField(fields[2]).val());

                if (age < minAge) {
                    hasErrors = true;
                    errorItems.push({
                        item: $item,
                        type: 'age'
                    });
                }
            }
		});

		if (errorItems.length > 0) {
			e.preventDefault();
			e.stopImmediatePropagation();

			$form.addClass('has-errors');

			$.each(errorItems, function(key, itemData) {
                // var errorType     = itemData.type || 'default';
                // var errorSettings = itemData.item.data('error-default');
                // var errorMessage  = errorSettings[errorType] || errorSettings['default'];
                var errorMessage = itemData.item.data('error-default');

				itemData.item.html(errorMessage);
			});

			$submit.removeClass('loading');

			setTimeout(function() {
				$submit.prop('disabled', false);
			}, 2000);

		} else {
			setTimeout(function() {
				$submit.prop('disabled', false);
			}, loadingMax * 1000);
		}

		checkInputErrors();
	});
});

function checkInputErrors() {
	var $allErrors = $('.input-errors-all');
	var $errorForm = false;

	$('.input-error').each(function() {
		var field  = $(this).attr('data-error-name');
		var $group = $(this).closest('.form-group');

		if ($(this).text().trim() !== '') {
			$errorForm = $(this).closest('form');
			$allErrors.find('[data-error-name="' + field + '"]').remove(); // Hide error in form top error listing
			$group.addClass('form-error');
			$(this).removeClass('hidden');

		} else {
			$group.removeClass('form-error');
			$(this).addClass('hidden');
		}
	});

	if ($allErrors.text().trim() === '') {
		$allErrors.hide();
	} else {
		$allErrors.slideDown('fast');
		$errorForm = $allErrors.closest('form');
	}

	var $firstError = $('.input-error:not(.hidden):first');

	if ($errorForm) {
		// If the error is in a modal, open the modal
		if ($errorForm.closest('.modal').length > 0) {
			$errorForm.closest('.modal').modal();

		} else {
			var $element = $firstError.closest('.form-group');

			if ($element.length === 0) {
				$element = $firstError;
			}

			setTimeout(function() {
				smoothScrollToCenter($element, $element.outerHeight() / 2, 500);
			}, 500);
		}
	}
}
